import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import APIUrls from '../../services/APIUrls'
import {dateFormat, getDateTimestamp, TIME_LIST_DATA, utcDateTimeWithTimeZone} from "../../services/Util";
import { useSelector, useDispatch } from 'react-redux'
import { getAxiosResponse } from '../../services/authApiRoutes/APImethods'
import { dateConvertToTimeStamp, TIME_LIST } from '../../services/Util'
import Select from 'react-select';
import DatePickerCalendar from '../dashboard/calendars/DatePickerCalendar';
import { updateProjectInfo } from '../../redux/reducers/ProjectInfoSlice';
import { updateProjectInfoValidation } from '../../redux/reducers/ProjectInfoValidationSlice';
import { updateBidRequestInfo } from '../../redux/reducers/BidRequestSlice';
import { transformBlankToNull } from '../../services/Util';
import { RotatingLines } from "react-loader-spinner";
import { updateVedorSelectSlice } from '../../redux/reducers/VendorSelectSlice';
import Constants from '../../Constants';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import $ from "jquery";
import { handleError } from '../../services/authApiRoutes/APImethods';
import moment from "moment";
import DateFormat from "../../pages/DateFormat";
import {DATE_FORMATS} from "../../services/DateUtil";

export const ExternalVendor = () => {

  const { t } = useTranslation();
	
	const translate = t;
	const [bidDueDateHoursList,setBidDueDateHourList]=useState(TIME_LIST_DATA)

	const [deliveryDueDateHoursList,setDeliveryDueDateHourList]=useState(TIME_LIST)
    const [needItSoonerStatus,setNeedItSooner]=useState(false)
  const [availableCurrency, setAvailableCurrency] = useState([]);
  const [customerVendor, setCustomerVendor] = useState([]);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [customerPurchaseOrder, setCustomerPurchaseOrder] = useState([])
  const [date, setMinDate] = useState(new Date());
  const [receiveQuotes, setReceiveQuotes] = useState(true)
  const [customerPurchaseOrderData, setCustomerPurchaseOrderData] = useState([])
  const [dateValidation, setDateValidation] = useState(false)
  const [translationVendor, setTranslationVendor] = useState([])
  const [projectDataCount,setProjectDataCount]=useState([])
  const [disableCheckbox, setDisableCheckbox] = useState(false)
  const[globalOverlay,showGlobalOverlay] = useState(true);
  const [permission,setPermission]=useState({});
    const [feature,setFeatures]=useState({})
const [autoSelectedBidRequest,setAutoSelectedBidRequest]=useState(false)
  const refToggle = useRef(null);
  const refToggle2 = useRef(null);
  const refCalendar = useRef(null);
  const refCalendar2 = useRef(null);

  const [toggle, toggleCal] = useState(false);
  const [toggleIntialCal, toggleIntialCalFlag] = useState(false);
   const [customerVendorOriginalData,setCustomerVendorOriginalData]=useState([]) 
  const [bidDueTime, setBidDueTime] = useState(-1)
  const [deliveryDueTime, setDeliveryDueTime] = useState(-1)

  const [bidSelectDeadlineDate, setBidSelectDeadlineDate] = useState("");
  const [projectBidDueDate, setProjectBidDueDate] = useState(null);
  const [projectDeliveryDueDate, setProjectDeliveryDueDate] = useState(null);
  const [deliveryDueDateHour,setDeliveryDueDateHour]=useState(TIME_LIST)
  const [bidDueDateHour,setBidDueDateHour]=useState(TIME_LIST);
  const [selectedVendors, setSelectedVendors] = useState(0);
  const [isPoSelectionMandatory, setPoSelectionMandatory] = useState(false);

  const dispatch = new useDispatch();

  const projectData = useSelector(
    (reduxStore) => reduxStore.project_info
  ).value;

  const bidRequestRedux = useSelector(
    (reduxStore) => reduxStore.bid_request
  ).value;

  const custBootstrapDataRedux = useSelector(
    (reduxStore) => reduxStore.customer_bootstrap_data
  ).value;

	const userTimeZone = custBootstrapDataRedux?.user?.timeZone;
    let userDateFormat = custBootstrapDataRedux?.dateFormatInDays?.toUpperCase();


  const setProjectInfoValidationToRedux = (type, value) => {
    dispatch(updateProjectInfoValidation({
      type: type,
      value: value
    }));
  }

  const dispatchFinalDataToRedux = (type, value) => {
    dispatch(updateProjectInfo({
      type: type,
      value: value
    }));
  }

  const dispatchFinalDataToToBidRequest = (type, value) => {
    dispatch(updateBidRequestInfo({
      type: type,
      value: value
    }));
  }

  useEffect(()=>{
    setTimeout(()=>{
      if (projectData?.deliveryDueDate) {
        const deliveryDueTime=utcDateTimeWithTimeZone(projectData?.deliveryDueDate,userTimeZone).hour()
        setDeliveryDueTime(deliveryDueTime)
        setProjectDeliveryDueDate(getDateTimestamp(projectData?.deliveryDueDate))
   }
   if (projectData?.bidDueDate) {
       const bidDueTime = utcDateTimeWithTimeZone(projectData?.bidDueDate, userTimeZone).hour()
       setBidDueTime(bidDueTime)
       setProjectBidDueDate(projectData?.bidDueDate?.dateWithTime)
   }
    },1000)
  },[])

  let MINIMUM_RUSH_BID_DUE_DATE_DELAY= 2
  let MINIMUM_BID_DUE_DATE_DELAY= 24



  const errorData = useSelector(
    (reduxStore) => reduxStore.project_info_validation_slice
  ).value;

  const selectUnselectCard = (index,data) => {
    if (projectData.projectVendorType === 'EXTERNAL') {
      const customerVendorCopy = [...customerVendor];
      if (customerVendorCopy && customerVendorCopy.length > 0) {
        
        customerVendorCopy[index].checked = !customerVendorCopy[index].checked;
        const selectedCount = customerVendorCopy.filter(obj => obj.checked).length;
        
        if (selectedCount > 5) {
          customerVendorCopy[index].checked = false;
        }
        setCustomerVendor(customerVendorCopy);
  
        const selectedCustomerVendor = customerVendorCopy.filter(obj => obj.checked).map(obj => obj.vendor);
        setSelectedVendors(selectedCount);
        dispatchFinalDataToToBidRequest('preferredVendors', selectedCustomerVendor);
      }
    }
    else {
      translationVendor.forEach((data, i) => {
        if (i === index) {
          data.checked ? data.checked = false  : data.checked = true
        } else {
          data.checked = false;
        }
        return data;
      })
      setTranslationVendor(translationVendor)
      const selectedVendor = translationVendor.filter(obj => obj.checked === true).map(obj => obj.vendor);
      dispatchFinalDataToToBidRequest('preferredVendors', selectedVendor)
    }

  }

  const externalVendorSelectionOnKeyDown = (event, index, data) => {
    if(event.key === Constants.ENTER) {
      selectUnselectCard(index, data);
    }
  }  


  const closeCalendar = (e) => {
    if (e.code === Constants.ESCAPE) {
      if ($('.cal-firstFocus').length) {
        toggleCal(false);
        $('.cal-firstFocus').trigger('focus')
        $('#cal-firstFocus').removeClass('cal-firstFocus')
      } else if ($('.cal-secondFocus').length) {
        toggleIntialCalFlag(false);
        $('.cal-secondFocus').trigger('focus')
        $('#cal-secondFocus').removeClass('cal-secondFocus')
      }
    }
  };

  const params = useParams()
  useEffect(() => { 
    if(custBootstrapDataRedux?.features?.INTERNATIONAL_CURRENCY) {
      getAllAvailableCurrency();
    }
    getFurtherInformation();
    getAllCustomerPurchaseOrder(projectData?.projectVendorType === "EXTERNAL" ? true : false);
    setMinDate(new Date().toISOString().slice(0, 10))
    
    if(!projectData.status){
      dispatchFinalDataToRedux(
        'status', 'CONFIGURED_BID_OPTIONS'
      )
    }
    if (projectData.bidDueDate) {
      setBidDueTime(moment(getDateTimestamp(projectData.bidDueDate)).hour())
    }
    if (projectData.deliveryDueDate) {
      setDeliveryDueTime(moment(getDateTimestamp(projectData.deliveryDueDate)).hour())
    }
    dispatch(updateVedorSelectSlice({}))
    getProjectBidRequest()
    getCustomerPermission()
    getPoSelectionMandatory();
    if(projectData?.bidDueDate !== null) {
      setProjectBidDueDate(getDateTimestamp(projectData?.bidDueDate));
    }
    if(projectData?.deliveryDueDate !== null) {
      setProjectDeliveryDueDate(getDateTimestamp(projectData?.deliveryDueDate));
    }
    setProjectInfoValidationToRedux('deliveryDueDate', Constants.BLANK);
    setProjectInfoValidationToRedux('bidDueDate', Constants.BLANK);
    setProjectInfoValidationToRedux('purchaseOrder', Constants.BLANK);
  }, [])

  useEffect(()  =>{
    checkDisable();
  },[customerVendor])

  useEffect(()=>{
     if(projectData.projectVendorType==='projectVendorType')  {
      setReceiveQuotes(false);
     }
  },[projectDataCount])

  useEffect(() => {
     setProjectInfoValidationToRedux('purchaseOrder', Constants.BLANK);
     if(availableCurrency.length !== 0 && receiveQuotes && isPoSelectionMandatory && customerPurchaseOrder?.length === 0){
         setProjectInfoValidationToRedux('purchaseOrder', "Please configure the Purchase Orders for the selected currency.");
     }
  },[isPoSelectionMandatory,customerPurchaseOrder,receiveQuotes,availableCurrency]);

  const getCustomerPermission = () => {
    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then(res => {
      setPermission(res?.data?.data?.permissions)
      setFeatures(res?.data?.data?.features)
    }).catch(err => {
      handleError(err)
    })
  }

  const getPoSelectionMandatory = () => {
    getAxiosResponse(APIUrls.PO_MANDATORY).then(res => {
      if (res.data.data.poForcedByAdmin || res.data.data.poForcedByUser) {
        setPoSelectionMandatory(true);
      } else {
        setPoSelectionMandatory(false);
      }
    }).catch(err => {
      handleError(err)
    })
  }

  const getProjectBidRequest = async (customerVendorCopy,translationVendorCopy) => {
    const dateTimestamp = dateConvertToTimeStamp();
    const result = await getAxiosResponse(APIUrls.BID_REQUEST_BY_ID(params.id) + `?_=${dateTimestamp}`)
     setAutoSelectedBidRequest(result?.data?.data?.autoSelectBid)  
    if (projectData.projectVendorType === 'EXTERNAL') {
      setReceiveQuotes(true);
      if (customerVendorCopy?.length>0) {
        if(result?.data?.data?.preferredVendors !== "") {
          result?.data?.data?.preferredVendors.forEach(obj => {
            customerVendorCopy.forEach(ven => {
              if (ven.vendor.id === obj.id) {
                ven.checked = true;
              }
            })
          })
        }
        const finalResult=transformBlankToNull(result?.data?.data?.preferredVendors);
        dispatchFinalDataToToBidRequest('preferredVendors', finalResult)
        setCustomerVendor(customerVendorCopy)
        setCustomerVendorOriginalData(customerVendorCopy)
        setTranslationVendor(translationVendorCopy);
      }
    }
    else {
      setReceiveQuotes(false);
      if (translationVendorCopy?.length>0) {
        if(result?.data?.data?.preferredVendors !== "") {
          result?.data?.data?.preferredVendors.forEach(obj => {
            translationVendorCopy.forEach(ven => {
              if (ven.vendor.id === obj.id) {
                ven.checked = true
              }
            })
          })
        }
      }
      const finalResult=transformBlankToNull(result?.data?.data?.preferredVendors);
      dispatchFinalDataToToBidRequest('preferredVendors', finalResult)
      setCustomerVendor(customerVendorCopy)
      setCustomerVendorOriginalData(customerVendorCopy)
      if(translationVendorCopy?.length === 0) {
        dispatch(updateBidRequestInfo({}))
      }
      setTranslationVendor(translationVendorCopy)
    }

  }

  const getAllAvailableCurrency = async () => {
    const dateTimestamp = dateConvertToTimeStamp();
    const result = await getAxiosResponse(APIUrls.AVAILABLE_CURRENCY(params.id) + `?_=${dateTimestamp}`)
    let options = result?.data?.data?.map((currency) => ({
      label : currency.label,
      value : currency.code,
      defaultValue : currency.defaultValue
    }))
    setAvailableCurrency(options)
  }

  const getFurtherInformation = async () => {
    const requestOne=getVendorDepartment(projectData?.userGroup?.id)
    const requestTwo=getTranslationVendor(projectData?.userGroup?.id)
    /* getting vendor and then getting the bid request for patching
    */
   
    await Promise.all([requestOne,requestTwo]).then(response=>{      
      getProjectBidRequest(response[0]?.data?.data,response[1]?.data?.data); 
       showGlobalOverlay(false);     
    })
  }

  const getVendorDepartment = async (depId) => {
    return getAxiosResponse(APIUrls.PREFERRED_VENDORS(depId))
  }
  const getTranslationVendor = async (id) => {
    return getAxiosResponse(APIUrls.TRANSALATION_VENDORS(id));
  }
  const getAllCustomerPurchaseOrder = async (status) => {
    const dateTimestamp = dateConvertToTimeStamp();
    const result = await getAxiosResponse(APIUrls.CUSTOMER_PURCHASE_ORDER + `?_=${dateTimestamp}`)
    setCustomerPurchaseOrderData(result?.data?.data)
    if(result.data.data &&  result.data.data.length > 0){
    const purchaseOrderData = 
    result.data.data.map(({ shortDisplay, id , currency}) => ({
      value: id,
      label: shortDisplay,
      currency: currency
    }))
    if(status === true) {
      setCustomerPurchaseOrder(purchaseOrderData.filter((order) => order.currency === projectData?.currency));
    } else {
      setCustomerPurchaseOrder(purchaseOrderData);
    }
    setPurchaseOrders(purchaseOrderData)
    setProjectDataCount(projectData)
  }
  } 

  const fieldChange = (event) => {
    dispatchFinalDataToRedux(event.target.name, event.target.value)
  }
  

  const setReceiveQuotesAndVendorType = (status) => {
    dispatchFinalDataToToBidRequest('preferredVendors', [])
    setReceiveQuotes(status);
    const vendors = customerVendorOriginalData.map((c) => {
      c.checked = false;
      return c;
    })
    setCustomerVendor([...vendors])
    setSelectedVendors(0);
    dispatchFinalDataToRedux('projectVendorType', status ? 'EXTERNAL' : 'EXTERNAL_BIDLESS')
    setProjectInfoValidationToRedux('purchaseOrder', Constants.BLANK);
    getAllCustomerPurchaseOrder(status);
  }
  const setCustomerPO = (event) => {
    if(event !==null){
      const po = customerPurchaseOrderData.filter(data => data.id == event?.value)
      dispatchFinalDataToRedux('purchaseOrder', po[0])
    }else{
      dispatchFinalDataToRedux('purchaseOrder', null)
    }
    setProjectInfoValidationToRedux('purchaseOrder', Constants.BLANK);
  }

  const setCurrencyAndPOs = (value) => {
    setCustomerPurchaseOrder(purchaseOrders.filter((order) => order.currency === value.value));
    dispatchFinalDataToRedux('currency', value.value)
  }


  $("#cal-firstFocus").on("keydown", function (e) {
   if (e.key === Constants.ESCAPE) {
     if($('div').hasClass('dashCalendarDeadLine')){
          showCalendarDueDate()
      }
    } else if (e.key === Constants.TAB && e.shiftKey) {
			if($('div').hasClass('dashCalendarDeadLine')){
				showCalendarDueDate();
			}
		}
  });
  $("#cal-secondFocus").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      if($('div').hasClass('dashCalendarMachine') || $('#cal-secondFocus').closest('.flex-center').find('.dashCalendarDeadLine').length){
        showCalendarDiliveryDate();
       }
     } else if (e.key === Constants.TAB && e.shiftKey) {
			if($('div').hasClass('dashCalendarMachine') || $('div').hasClass('dashCalendarDeadLine')){
				showCalendarDiliveryDate();
			}
		}
   });
  
   const calculateBidSelectDeadlineDate = (bidDueDate, deliveryDueDate) => {
    let date;	  
      if (bidDueDate !== null && deliveryDueDate !== null) {
          var newBidDueDate = utcDateTimeWithTimeZone(
              bidDueDate,
              userTimeZone
          );
          var newDeliveryDueDate = utcDateTimeWithTimeZone(
              deliveryDueDate,
              userTimeZone
          );
          var differenceInHours = Math.round(
              (new Date(newDeliveryDueDate._d).getTime() -
                  new Date(newBidDueDate._d).getTime()) /
              (60 * 60 * 1000)
          );

          differenceInHours = differenceInHours * 0.25;

          var hoursToAddToBidDueDate = Math.abs(differenceInHours);

          if (hoursToAddToBidDueDate < 2) {
              hoursToAddToBidDueDate = 2;
          }
          var bidSelectionDate = utcDateTimeWithTimeZone(
              newBidDueDate,
              userTimeZone
          );
          var updatedDate = new Date(bidSelectionDate).setHours(
              new Date(bidSelectionDate).getHours() + hoursToAddToBidDueDate
          );

          var bidSelectDeadlineDate = new Date(updatedDate).getTime();

          setBidSelectDeadlineDate(bidSelectDeadlineDate);
    date=moment(updatedDate);
      }
  return date;
  }

  const checkDisable =  () =>{
    if(customerVendor && customerVendor.length>0){
    let selectedCustomers=  customerVendor.filter(obj=>obj.checked===true);
    if(selectedCustomers && selectedCustomers.length>1){
      setDisableCheckbox(true)
      return;
    }
    } 
    else{
      setDisableCheckbox(false)
    }
  }


  const showCalendarDueDate = () => {
    toggle ? toggleCal(false) : toggleCal(true);
    $('#cal-firstFocus').toggleClass('cal-firstFocus');
		$('.cal-firstFocus').trigger('focus');
		$(document).mouseup(function(e) {
		  var bannerCont = $('.cal-firstFocus');
		  if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
			$('#cal-firstFocus').removeClass('cal-firstFocus');
		  }
		});
    if (toggle) {
      var requiredElement = document.querySelector(".dashCalendar")
      if(requiredElement !== null) {
        requiredElement.focus();
      }
    }
  };

  const showCalendarDiliveryDate = () => {
    toggleIntialCal ? toggleIntialCalFlag(false) : toggleIntialCalFlag(true);
    $('#cal-secondFocus').toggleClass('cal-secondFocus');
		$('.cal-secondFocus').trigger('focus');
		$(document).mouseup(function(e) {
		  var bannerCont = $('.cal-secondFocus');
		  if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
			$('#cal-secondFocus').removeClass('cal-secondFocus');
		  }
		});
    if (toggleIntialCal) {
      var requiredElement = document.querySelector(".dashCalendar2");
      if(requiredElement !== null) {
        requiredElement.focus();
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        refCalendar.current &&
        !refCalendar.current?.contains(event.target) &&
        !refToggle.current?.contains(event.target)
      ) {
        toggleCal(false);
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [refCalendar]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        refCalendar2.current &&
        !refCalendar2.current.contains(event.target) &&
        !refToggle2.current.contains(event.target)
      ) {
        toggleIntialCalFlag(false);
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [refCalendar2]);

  const autoSelectedBid =(event) =>{
    dispatchFinalDataToRedux('autoSelectBid', event.target.checked)
  }


  useEffect(()=>{
    dispatchFinalDataToRedux('autoSelectBid', autoSelectedBidRequest)
  },[autoSelectedBidRequest])

  // useEffect(() => {
  //   calculateBidSelectDeadlineDate(projectBidDueDate, projectDeliveryDueDate);
  // }, [projectBidDueDate, projectDeliveryDueDate])

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isdisabled ? 'gray' : 'black', // Change color of disabled options
      cursor: state.isDisabled ? 'not-allowed' : 'default', // Change cursor style for disabled options
      // Add more custom styling properties as needed
    }),
  };
  useEffect(()=>{
		$.each($('.react-calendar__tile'), function( index, value ) {
		  $(value).attr('aria-label', value.children[0].ariaLabel);
		});
	}); 
  const [refs, setRefs] = useState({});
  const submitBidsTooltipRef = useRef(null);
  const translationTooltipRef = useRef(null);
  const selectionTooltipRef = useRef(null);
  $('.tooltip-container p').on('keydown', function(e){
    if(e.key === Constants.ESCAPE){
      if ($(this).attr('id') === "submitBidsTooltip") {
        setRefs(submitBidsTooltipRef);
      }
      else if ($(this).attr('id') === "translationTooltip") {
        setRefs(translationTooltipRef);
      }
      else if ($(this).attr('id') === "selectionTooltip") {
        setRefs(selectionTooltipRef);
      }
    }
  });
  useEffect(()=>{
   if (refs.current) {
      refs.current.hideTooltip();
      setRefs({});
    }
  }, [refs]);

  
  const getValidBidDueHourForDate=(bidDueDate)=> {
    var validHours = [];
    var bidDue =moment(bidDueDate);
    for (var i = 0; i < 24; i++) {
      bidDue.add(1,"hour");
      if (isValidBidDueDate(bidDue ,false)) {
      validHours.push(i);
      }
    }
    return validHours;
    }
  
    const isValidBidDueDate=(bidDueDate, alwaysAllowSameDay)=>{
    return !isLessThanMinimumBidDueDate(bidDueDate, alwaysAllowSameDay);
    }
    
    const isLessThanMinimumBidDueDate=(bidDueDate,alwaysAllowSameDay)=>{
    // in user's configured time zone
    var date = moment(bidDueDate);
    var minBidDueDate = date;
  
    if (!allowRushProject()) {
      alwaysAllowSameDay = false;
    }
  
    if (alwaysAllowSameDay) {
      // set the proposed date ("bidDueDate") to be at the same time of day as now
      date.set({
      'hour': minBidDueDate.hours(),
      'minute': minBidDueDate.minutes(),
      'second': minBidDueDate.seconds(),
      'millisecond': minBidDueDate.milliseconds(),
      });	  
    }
  
    // calculate minimum bid due date
    // bump to next full hour if now is not exactly on an hour
    minBidDueDate.set({
      'hour': minBidDueDate.hours() > 0?0:minBidDueDate.hours(),
      'minute': minBidDueDate.minutes()> 0?0:minBidDueDate.minutes(),
      'second': minBidDueDate.seconds()> 0?0:minBidDueDate.seconds(),
      'millisecond': minBidDueDate.milliseconds()> 0?0:minBidDueDate.milliseconds(),
      });
  
    if (allowRushProject) {
      // if rush project is allowed
      // minimum bid due date is plus one hour from the full hour is the
      // server-side limit; we need to limit that to two hours here to
      // account for time spent building the TM snapshot
      minBidDueDate.add(MINIMUM_RUSH_BID_DUE_DATE_DELAY, 'hour');
    } else {
      // rush project is not allowed
      // minimum bid due date is plus 24 hours from the full hour
      minBidDueDate.add(MINIMUM_BID_DUE_DATE_DELAY,"hour");
    }
  
    var isDateAcceptable = false;
    const isSameDay = date.isSame(minBidDueDate, 'day');
    if (alwaysAllowSameDay && isSameDay) {
      // if minimum bid due date is still on the same date as the proposed date, we allow this 
      // date to be selected in date picker
      isDateAcceptable = true;
    } else {
      // else, a date is selectable if it is on or after the minimum date
      isDateAcceptable = date.isSameOrAfter(minBidDueDate)
    }
    return !isDateAcceptable;
    }
  
  
  const getValidDeliveryDueHourForDate = (deliveryDueDate, bidDueDate, timeZone)=> {
    var validHours = [];
    var deliveryDue = moment(deliveryDueDate);
    for (var i = 0; i < 24; i++) {
  
      deliveryDue.add(i,"hour");
      if (isValidDeliveryDueDate(deliveryDue, bidDueDate, timeZone, false)) {
      validHours.push(i);
      }
    }
    return validHours;
    }
  
    const isValidDeliveryDueDate=(deliveryDueDate, bidDueDate, timeZone, alwaysAllowSameDay)=>{
    return isDeliveryDueDateAfterBidDueDate(deliveryDueDate, bidDueDate, timeZone) &&
      !isLessThanMinimumDeliveryDueDate(deliveryDueDate, timeZone, alwaysAllowSameDay);
    }
  
    const isDeliveryDueDateAfterBidDueDate=(deliveryDueDate, bidDueDate, timeZone)=> {
    if (bidDueDate == null) {
      return true;
    }
  
    var bidDue = moment(bidDueDate);
    var deliveryDue = moment(deliveryDueDate);
    const minimumDuration = allowRushProject() ? 4 : 24; // hours
    const durationDifference = moment.duration(deliveryDue.diff(bidDue)).asHours();
    return durationDifference >= minimumDuration;
    }
  
    const isLessThanMinimumDeliveryDueDate = (deliveryDueDate, timeZone, alwaysAllowSameDay) => {
    // in user's configured time zone
    const date = moment.tz(deliveryDueDate, timeZone);
    
    let minDeliveryDueDate = moment.tz(timeZone);
    
    if (projectData?.status?.inProgress && projectData?.deliveryDueDate && projectData?.deliveryDueDate) {
      minDeliveryDueDate = moment.tz(projectData?.deliveryDueData, timeZone).subtract(1, 'days');
    }
    
    if (!allowRushProject()) {
      alwaysAllowSameDay = false;
    }
    
    if (alwaysAllowSameDay) {
      // set the proposed date ("deliveryDueDate") to be at the same time of day as now
      date.set({
      'hour': minDeliveryDueDate.hours(),
      'minute': minDeliveryDueDate.minutes(),
      'second': minDeliveryDueDate.seconds(),
      'millisecond': minDeliveryDueDate.milliseconds(),
      });
    }
    
    // calculate minimum delivery due date
    // bump to the next full hour if now is not exactly on an hour
    minDeliveryDueDate.startOf('hour');
    
    if (allowRushProject()) {
      // if rush project is allowed
      // minimum delivery due date is plus six hours from the full hour
      minDeliveryDueDate.add(6, 'hours');
    } else {
      // rush project is not allowed
      // minimum delivery due date is plus 48 hours from the full hour
      minDeliveryDueDate.add(48, 'hours');
    }
    
    let isDateAcceptable = false;
    if (alwaysAllowSameDay && date.isSame(minDeliveryDueDate, 'day')) {
      // if the minimum delivery due date is still on the same date as the proposed date, we allow this 
      // date to be selected in the date picker
      isDateAcceptable = true;
    } else {
      // else, a date is selectable if it is on or after the minimum date
      isDateAcceptable = date.isSameOrAfter(minDeliveryDueDate);
    }
    return !isDateAcceptable;
    };
    
    const onBidDueDaySelect=(event)=>{
    var newBidDueDate = moment(event).set({
      'hour': 0,
      'minute': 0,
      'second': 0,
      'millisecond': 0,
      });
    // newBidDueDate = utcDateTimeWithTimeZone(event)		
    var newBidDueDateHour = bidDueTime===-1?0:bidDueTime;
    if(newBidDueDateHour) {
      // if the bid due hour is specified, set it
      // otherwise, the hour will get adjusted by the "onDateChanged" call to the first available hour for this day
      newBidDueDate.add(parseInt(newBidDueDateHour),"hours");				
    }
    // update model

    if(!newBidDueDateHour) {
      // if the bid due date hour is not set, and 5PM is an available option for the selected bid due date
      // default to 5PM
      var fivePM = bidDueDateHoursList.find(data=>data.value ===17);
      if(!fivePM.isDisabled) {
        setBidDueTime(17)
      newBidDueDate.add(parseInt(17),"hours");				

      }
    }
    dispatchFinalDataToRedux('bidDueDate', newBidDueDate)
    dispatchFinalDataToRedux('bidDueDateChanged', true)
    $('.cal-secondFocus').trigger('focus')
     $(document).on('mouseup', function(e) {
       var bannerCont = $('.cal-secondFocus');
       if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
         $('.cal-secondFocus').trigger('focus')
         $('#cal-secondFocus').removeClass('cal-secondFocus')
       }
     });
    toggleCal(false);
  }
  
  const bumpDeliveryDueDateIfNecessary =(newBidDueDate)=>{
    // are there still valid delivery due date hour for the current delivery day?
      const isDeliveryDateStillValid = deliveryDueDateHoursList.filter(data=>data.value !==-1)?.some(option => !option.isDisabled)?.length > 1;
    if(!isDeliveryDateStillValid) {
      // if not, bump by one day
      var bidDue = moment(newBidDueDate)	
      bidDue.add(1, 'day');
      dispatchFinalDataToRedux('deliveryDueDate', bidDue)
      dispatchFinalDataToRedux('deliveryDueDateChanged', true)		
      onDeliveryDueDaySelect(bidDue);
      onDateChanged(newBidDueDate,bidDue)
    }
  }
  

  const onDeliveryDueDaySelect = (event)=> {
    var newDeliveryDueDate = moment(event).set({
      'hour': 0,
      'minute': 0,
      'second': 0,
      'millisecond': 0,
      });
    var newDeliveryDueDateHour = deliveryDueTime===-1?0:deliveryDueTime;
    if(newDeliveryDueDateHour) {
      // if the delivery due hour is specified, set it
      // otherwise, the hour will get adjusted by the "onDateChanged" call to the first available hour for this day
      newDeliveryDueDate.add(newDeliveryDueDateHour,"hours");				
    }
    // update model

    if(!newDeliveryDueDateHour) {
      // if the bid due date hour is not set, and 5PM is an available option for the selected bid due date
      // default to 5PM
      var fivePM = deliveryDueDateHoursList.find(data=>data.value ===17);
      if(!fivePM?.isDisabled) {
        setDeliveryDueTime(21)
      newDeliveryDueDate.add(21,"hours");				

      } else {
        fivePM=deliveryDueDateHoursList.filter(data=> !data.isDisabled);
                  if(fivePM && fivePM.length > 0){
                   setDeliveryDueTime(fivePM[0]?.value)
      newDeliveryDueDate.add(fivePM[0]?.value,"hours");				

          }
      }
    }
    dispatchFinalDataToRedux('deliveryDueDate', newDeliveryDueDate)
    dispatchFinalDataToRedux('deliveryDueDateChanged', true)		
    onDateChanged(projectData.bidDueDate,newDeliveryDueDate)

    if(!allowRushProject()) {
      var now = moment.tz(userTimeZone);
      now.add(48,"hours");
        const isSameDay = now.isSame(newDeliveryDueDate, 'day');
      if(isSameDay) {
        setNeedItSooner(true)  
      }
    }
    $('.cal-secondFocus').trigger('focus')
    $(document).on('mouseup', function(e) {
      var bannerCont = $('.cal-secondFocus');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        $('.cal-secondFocus').trigger('focus')
        $('#cal-secondFocus').removeClass('cal-secondFocus')
      }
    });
    toggleIntialCalFlag(false)
  }

  const onDeliveryDueDateHourChange =(e)=> {
    if(projectData.deliveryDueDate) {
      var deliveryDueDate = moment(getDateTimestamp(projectData.deliveryDueDate))
      var hour =parseInt(e?.value);
      deliveryDueDate.set({
        'hour': hour,
        'minute': 0,
        'second': 0,
        'millisecond': 0,
        })
      setDeliveryDueTime(hour)
      // update model
      dispatchFinalDataToRedux('deliveryDueDate', deliveryDueDate)
      dispatchFinalDataToRedux('deliveryDueDateChanged', true)	
      onDateChanged(projectData?.bidDueDate,deliveryDueDate)	
    }
  }
  const onBidDueDateHourChange =(e)=> {
    if(projectData?.bidDueDate) {
      var bidDueDate =moment(getDateTimestamp(projectData?.bidDueDate))
      var hour = parseInt(e.value);
      bidDueDate.set({
        'hour': hour,
        'minute': 0,
        'second': 0,
        'millisecond': 0,
        })
      setBidDueTime(hour)
      // update model
      dispatchFinalDataToRedux('bidDueDate', bidDueDate)
      dispatchFinalDataToRedux('bidDueDateChanged', true)
      bumpDeliveryDueDateIfNecessary(bidDueDate);	
    }
  }
  const onDateChanged =(bidDueDate,deliveryDueDate)=>{
    // update the valid hours for selection
    // updateValidBidDueDateHours();
    // updateValidDeliveryDueDateHours();
    var newBidSelectDeadline = calculateBidSelectDeadlineDate(bidDueDate,deliveryDueDate);
      // recalculate bid selection date for display
      if(newBidSelectDeadline) {
        setBidSelectDeadlineDate(new Date(newBidSelectDeadline));
      dispatchFinalDataToRedux('bidSelectDeadlineDate', newBidSelectDeadline)
          showBidSelectWarningIfNecessary();	
    }
  }
  
  const showBidSelectWarningIfNecessary =()=> {
    if(projectData?.bidSelectDeadlineDate && (!projectData.status || !projectData?.status?.bidSelected)) {
      var newBidSelectDeadline = moment(projectData.bidSelectDeadlineDate).tz(userTimeZone);
      // var bidSelectContainer = jQuery(this.el).find(".bidSelectDeadlineContainer");
      var bidSelectContainer =null;
      var bidSelectDay = newBidSelectDeadline?.day();
      var bidSelectHour = newBidSelectDeadline?.hours();
      var fallsOnWeekend = bidSelectDay < 1 || bidSelectDay > 5; // falls on weekend
      var outsideCoreHours = bidSelectHour < 9 || bidSelectHour > 17; // outside of core business hours 9-5pm
    }
  }
  


  
  const allowRushProject =()=> {
    return custBootstrapDataRedux?.features?.RUSH_PROJECT;
  }

  return (
    <>
      <div className="translate-project translate-vender">
        <div className="project-heading mar-bot10">
          <h3>External Translator</h3>
        </div>
        <div className="vendor-content">
          {(feature?.BIDLESS_PROJECTS && translationVendor?.length > 0) ? <div className="group-radio-list" role="radiogroup" aria-labelledby="radioDesc">
            <p id='radioDesc'>{translate("project_listing.prior_translation")}</p>
            <div className="flex">
              <div className="radio-form-check">
                <input type="radio" onChange={() => setReceiveQuotesAndVendorType(true)} value={projectData?.projectVendorType === 'EXTERNAL'} checked={projectData?.projectVendorType === 'EXTERNAL'} className="form-check-input" name="radio" id="yes" />
                <label className="form-check-label" htmlFor="yes">
                  Yes
                </label>
              </div>
              <div className="radio-form-check">
                <input type="radio" onChange={() => setReceiveQuotesAndVendorType(false)} value={projectData?.projectVendorType === 'EXTERNAL_BIDLESS'} checked={projectData?.projectVendorType === 'EXTERNAL_BIDLESS'} className="form-check-input" name="radio" id="no" />
                <label className="form-check-label" htmlFor="no">
                  No
                </label>
              </div>
            </div>
          </div> : <></>}

          {
            receiveQuotes ?
              <>
                <h5 className='m-0'>{translate("project_listing.vendors_request")}</h5>
                {(customerVendor && customerVendor.length > 0) ? <p id='selectVendor' className='pref-vendor-limit'>{translate("project_listing.select_5_vendors")}</p> : <p>Please contact OPAL-Marketing to configure vendors for this department. <a target={"_blank"} href='/vendor/customer-vendor/'>Add preferred vendors</a> to your account to request quotes from your preferred vendors.</p>}
                <div className="translate-box flex" role="group" aria-labelledby="selectVendor">
                  {
                    customerVendor && customerVendor.length > 0 && customerVendor.map((data, index) => (
                      <div  key={index} className="translate-box-list" role='none'>
                        <a createproject-tour="chooserequest-vendor" role="radio"
                          aria-checked={data.checked === true ? 'true' : 'false'}
                          tabindex="0"
                          onClick={() => selectUnselectCard(index, data)}
                          onKeyDown={(e) => externalVendorSelectionOnKeyDown(e, index, data)}
                          className={`vendor-card ${data.checked ? 'vendor' : selectedVendors >= 5 ? 'disable-vendor-card' : ''}`}>
                          <span>{data.vendor.name}</span>
                        </a>
                      </div>
                    ))
                  }
                </div>
              </>

              : null
          }
          {
            !receiveQuotes ? <>
              {translationVendor?.length > 0 && <h5 id='preferVendor'>{translate("other_integrations_project_creation.preferred_vendor_selection_heading")}</h5>}
              {translationVendor?.length === 0 && <p className='error-alert'>{translate("other_integrations_project_creation.preferred_vendor_selection_error")}</p>}
              <div className="translate-box flex" aria-labelledby="preferVendor" role="group">
                {
                 translationVendor && translationVendor.length > 0 && translationVendor.map((data, index) => (
                    <div key={index} className="translate-box-list" role="none">
                      <a tabindex="0"
                       role="radio"
                       aria-checked={data.checked === true ? 'true' : 'false'}
                       onClick={() => selectUnselectCard(index, data)} onKeyDown={(e) => externalVendorSelectionOnKeyDown(e, index, data)}
                       className={data.checked  === true ? ' vendor' : ''}>
                        <span>{data.vendor.name}</span>
                      </a>
                    </div>
                  ))
                }
              </div>
            </> : null
          }
        {feature?.AUTO_APPROVE_BID && permission?.BID_AUTO_APPROVAL?  <div className="approve-block">
            {
              receiveQuotes ? <><h5>Automatically approve quote?</h5>
                <p>Select the option below to have the quote submitted by the vendor automatically approved. This option is only available when the project is sent to only one of your preferred vendors listed above.</p>
                <div className="radio-form-check">
                  <input  disabled={bidRequestRedux?.preferredVendors?.length !==1 || autoSelectedBidRequest}   value={projectData?.autoSelectedBid} onChange={autoSelectedBid} type="checkbox" className="form-check-input" name="vendor" id="yesVender"/>
                  <label className="form-check-label" htmlFor="yesVender">
                    Yes - automatically approve quote submitted by Vendor
                  </label>
                </div>  </> : null
            }
          </div>:""}
          <div className="vender-form-block">
            <h5>{translate("project_listing.vendors_deadline")}</h5>
            <div createproject-tour="deadlines">
            {receiveQuotes ? <div className="flex wrap-dropdown wrap-group-dropdown">
              <div className="global-dropdown-block flex-center">
              <div className="tooltip-container">
                <h6>Vendors must submit quotes by</h6>
                <p
                  tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
                  data-padding="10px 10px 10px 10px"
                  data-place="right"
                  data-tip={Constants.BID_SUBMISSION_TOOLTIP}
                  data-for="bid-submission-tooltip"
                  aria-label="Tooltip"
                  id="submitBidsTooltip"
                >
                  <svg
                    className="svg-tooltip-icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                  </svg>
                  <div className="font-zero">{Constants.BID_SUBMISSION_TOOLTIP}</div>
                </p>
                <ReactTooltip
                  className="tooltip"
                  id="bid-submission-tooltip"
                  role="tooltip"
                  ref={submitBidsTooltipRef}
                ></ReactTooltip>
              </div>
                <div className="flex-center w-d100">
                  <div className="global-dropdown-select">
                    <label htmlFor='cal-firstFocus' className='font-zero'>Vendors must submit quotes by</label>
                    <button
                      id='cal-firstFocus'
                      aria-haspopup="dialog"
                      required
                      aria-expanded={toggle ? 'true':'false'}
                      aria-label={ projectData?.bidDueDate ? `Vendors must submit quotes by ${dateFormat(projectData?.bidDueDate, userDateFormat)} selected` :  ''}
                      aria-describedby="bidDueDateRequired"
                      onClick={(e) => {
                        showCalendarDueDate(e);
                      }}
                      ref={refToggle}
                      className="drop-down-btn gb-dropBtn">
                      <span>{projectData?.bidDueDate ? ( projectData.bidDueDate?.dateWithTime ? projectData?.bidDueDate?.date : dateFormat(projectData?.bidDueDate, userDateFormat)) : " "}</span>
                      <span className="font-zero">{projectData?.bidDueDate ? ( projectData.bidDueDate?.dateWithTime ? projectData?.bidDueDate?.date : dateFormat(projectData?.bidDueDate, userDateFormat)) :"Bid due date"}</span>
                      <svg
                      aria-hidden="true"
                        className="calender-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                          fill="#3564EB"
                        />
                      </svg>

                    </button>
                   

                  </div>
                  {toggle ? (<div ref={refCalendar}
                    onKeyDown={(e) => {
                      closeCalendar(e);
                    }}>
                  <DatePickerCalendar 
                    value={new Date(getDateTimestamp(projectData?.bidDueDate))}
                    className="dashCalendarDeadLine"
                    minDate={new Date()}
                    selectDate={onBidDueDaySelect}
                  />
                  </div>) : (
                    ""
                  )}
                  <div className="global-dropdown-select small-dropdown-select">
                  <Select className="" classNamePrefix='cw'
                    value={bidDueDateHour.filter(function (option) {
                      return option?.value === bidDueTime;
                    })}
                    aria-label="What Time?"
                    onChange={event => onBidDueDateHourChange(event)}
                    options={bidDueDateHour}
                    menuShouldScrollIntoView={false}
                    isOptionDisabled={(option) => option.isdisabled}
                    styles={customStyles}
                  />
                   </div>
                </div>
                {errorData.bidDueDate ? <p className='textDanger' id="bidDueDateRequired">{errorData.bidDueDate === true ? 'Please enter a valid date': errorData.bidDueDate }</p> : null}
              </div>
            </div> : null}
            <div className="flex wrap-dropdown wrap-group-dropdown">
              <div className="global-dropdown-block flex-center">

                <div className="tooltip-container">
                  <h6>I need initial translation by</h6>
                  <p
                    tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
                    data-padding="10px 10px 10px 10px"
                    data-place="right"
                    data-tip={Constants.TRANSLATION_SUBMISSION_TOOLTIP}
                    data-for="translation-submission-tooltip"
                    aria-label="Tooltip"
                    id='translationTooltip'
                  >
                    <svg
                      className="svg-tooltip-icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                    </svg>
                    <div className="font-zero">{Constants.TRANSLATION_SUBMISSION_TOOLTIP}</div>
                  </p>
                  <ReactTooltip
                    className="tooltip"
                    id="translation-submission-tooltip"
                    role='tooltip'
                    ref={translationTooltipRef}
                  ></ReactTooltip>
                </div>
                <div className="flex-center w-d100">
                  <div className="global-dropdown-select">
                    <label htmlFor='cal-secondFocus' className='font-zero'>I need initial translation by</label>
                    <button
                      onClick={(e) => {
                        showCalendarDiliveryDate(e);
                      }}
                      required
                      aria-expanded={toggleIntialCal ? 'true':'false'}
                      aria-label={ projectData?.deliveryDueDate ? `I need initial translation by ${dateFormat(projectData?.deliveryDueDate, userDateFormat)} selected` :  ''}
                      ref={refToggle2}
                      tabIndex={0}
                      id='cal-secondFocus'
                      aria-describedby="deliveryDueDate"
                      type="button" className="drop-down-btn gb-dropBtn">
                      <span>{projectData?.deliveryDueDate ? (projectData.deliveryDueDate?.dateWithTime ? projectData.deliveryDueDate.date : dateFormat(projectData?.deliveryDueDate, userDateFormat)) : ""}</span>
                      <span className="font-zero">{projectData?.deliveryDueDate ? (projectData.deliveryDueDate?.dateWithTime ? projectData.deliveryDueDate.date : dateFormat(projectData?.deliveryDueDate, userDateFormat)) :"Delivery due Date"}</span>
                      <svg
                      aria-hidden="true"
                        className="calender-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                          fill="#3564EB"
                        />
                      </svg>

                    </button>
                  </div>
                  {toggleIntialCal ? (<div ref={refCalendar2}
                    onKeyDown={(e) => {
                      closeCalendar(e);
                    }}>
                    <DatePickerCalendar
                    minDate={projectData?.bidDueDate ? new Date(getDateTimestamp(projectData?.bidDueDate)):new Date()}
                    className={receiveQuotes ? "dashCalendarMachine" : " dashCalendarDeadLine"}  
                    value={projectData?.deliveryDueDate ? new Date(getDateTimestamp(projectData?.deliveryDueDate)):new Date()}
                    selectDate={onDeliveryDueDaySelect} 
                  />
                  </div>) : (
                    ""
                  )}
                  <div className="global-dropdown-select small-dropdown-select">
                  <Select className="" classNamePrefix='cw'
                    value={TIME_LIST.filter(function (option) {
                      return option?.value === deliveryDueTime;
                    })}
                    aria-label="What Time?"
                    onChange={event => onDeliveryDueDateHourChange(event)}
                    options={deliveryDueDateHour}
                    isOptionDisabled={(option) => option.isdisabled}
                    menuShouldScrollIntoView={false}
                    styles={customStyles}
                  />
                  </div>

                </div>
                {errorData.deliveryDueDate ? <p className='textDanger' id="deliveryDueDate">{errorData.deliveryDueDate === true ? 'Please enter a valid date': errorData.deliveryDueDate }</p> : null}
              </div>
              {projectData?.projectRequestDueDate?.date &&
                <p>Note: The requester asked for the translations to be finalized by  {projectData?.projectRequestDueDate?.date}. </p>}
            </div>
            {receiveQuotes ? <div className="flex wrap-dropdown wrap-group-dropdown">
              <div className="global-dropdown-block flex-center">
                <div className="tooltip-container">
                  <h6>You will have to select the quote by</h6>
                  <p
                    tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
                    data-padding="10px 10px 10px 10px"
                    data-place="right"
                    data-tip={Constants.BID_SELECTION_DEADLINE_TOOLTIP}
                    data-for="bid-selection-deadline-tooltip"
                    aria-label="Tooltip"
                    id='selectionTooltip'
                  >
                    <svg
                      className="svg-tooltip-icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                    </svg>
                    <div className="font-zero">{Constants.BID_SELECTION_DEADLINE_TOOLTIP}</div>
                  </p>
                  <ReactTooltip
                    className="tooltip"
                    role='tooltip'
                    id="bid-selection-deadline-tooltip"
                    ref={selectionTooltipRef}
                  ></ReactTooltip>
                </div>
                  {bidSelectDeadlineDate !== "" ? <span
                    className="alert-icon"
                  >
                    {/* If date is proccessed by BE, then we have dateWithTime, else we have date format only and time need to parse manually */}
                    <DateFormat date={bidSelectDeadlineDate} timezone={null} /> {"at "}
                    <DateFormat date={bidSelectDeadlineDate} format={DATE_FORMATS.TIME_OF_DAY} timezone={null} />
                  </span> :
                    projectData?.bidSelectDeadlineDate !== null ?
                      (<span
                        className="alert-icon"
                      >{projectData?.bidSelectDeadlineDate?.dateWithTime ? projectData?.bidSelectDeadlineDate?.date : dateFormat(projectData?.bidSelectDeadlineDate, userDateFormat)} at {projectData?.bidSelectDeadlineDate?.timeOfDay ? projectData?.bidSelectDeadlineDate?.timeOfDay : dateFormat(projectData?.bidSelectDeadlineDate, DATE_FORMATS.TIME_OF_DAY)}
                      </span>) :
                      (<span>To be determined based on your quote submission and initial translation deadline</span>)}
              </div>
            </div> : null}
            </div> 

            {availableCurrency.length !== 0 && receiveQuotes && <div className="flex wrap-dropdown">

              <div className="global-dropdown-block flex-center">
                <label>Project Currency</label>
                <div className="global-dropdown-select">
                  <Select className="global-dropdown-select requiredInput" classNamePrefix='cw'
                    aria-label="Project Currency"
                    menuShouldScrollIntoView={false}
                    options={availableCurrency}
                    value={availableCurrency.filter(function (option) {
                      return option?.value === projectData?.currency;
                    })}
                    onChange={(value) => setCurrencyAndPOs(value)}
                  />
                </div>
              </div>
            </div>}
            

            <div className="flex wrap-dropdown">

              <div className="global-dropdown-block flex-center">
                <label>{translate("project_listing.purchase_order_number")} 
                  <div className='tooltip-container optional-tooltip'>
                    <p tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
                    data-padding='10px 10px 10px 10px'
                    id='purchaseOrderTooltip'
                    aria-label='tooltip'
                    data-place='bottom'
                    data-tip={Constants.PURCHASE_ORDER_TOOLTIP}
                    data-for='purchaseOrderTip'>
                      <svg className="svg-tooltip-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                      </svg>
                      <div className="font-zero">{Constants.PURCHASE_ORDER_TOOLTIP}</div>
                    </p>
                    <ReactTooltip
                    className='tooltip'
                    id='purchaseOrderTip'
                    role='tooltip'
                    ></ReactTooltip>
                  </div>
                  <span>{translate("project_listing.optional")}</span>
                </label>
                <div className="global-dropdown-select">
                  <Select className="global-dropdown-select" classNamePrefix='cw'
                    value={customerPurchaseOrder.filter(function (option) {
                      return option?.value === projectData?.purchaseOrder?.id;
                    })}
                    aria-label="Purchase Order Number (Optional)"
                    options={customerPurchaseOrder}
                    isClearable={true}
                    onChange={e => setCustomerPO(e)}
                    menuShouldScrollIntoView={false}
                  />
                </div>
                {errorData.purchaseOrder && <p className='textDanger'>{errorData.purchaseOrder}</p>}
              </div>
            </div>
            <div className="flex wrap-dropdown textarea-group mar-bot10">
              <div className="global-dropdown-block flex-center mb-0">
                <label htmlFor='descriptions'>{translate("project_listing.vendors_instruction")} <span> {translate("project_listing.optional")}</span></label>
                <textarea maxLength="2500" id='descriptions' className="textarea" name='notes' value={projectData.notes} onChange={event => fieldChange(event)} placeholder={translate("project_listing.charactacters_limit")}></textarea>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>                
    </>
  )
}
